import React from 'react';

import styles from './MobileOrderProducts.module.css'
import {cn} from "../../../../../utils/cn.ts";
import {Button} from "../../../../../ui/General/Button/Button.tsx";
import {Order} from "../../../../../types/Order.interface.ts";

interface Props {
    orderOffer: Order,
    getPaymentUrl: (orderId: number) => void,
}


export const MobileOrderProducts: React.FC<Props> = ({orderOffer, getPaymentUrl,}) => {
    const totalAmount = orderOffer.products.reduce((prev, next) => {return prev + next.amount}, 0);

    return (
        <>
            <h3 className={styles.title}>Ваш заказ № {orderOffer.orderNumber}</h3>
            <div className={styles.outline}/>
            <h2 className={styles.title}>Товары в заказе</h2>
            <ul className={styles.productList}>
                {orderOffer.products.map(({id, name, brand, article, price, amount,}) => (
                    <li key={id} className={cn(
                        styles.product,
                    )}>
                        <div className={styles.name}>{name}</div>
                        <div className={styles.info}>
                            <div className={styles.brand}>{brand}</div>
                            <div className={styles.productId}>{article}</div>
                        </div>
                        <div className={styles.price}>{price} ₽</div>
                        <div className={styles.counterWrapper}>
                            <div className={styles.amountWrapper}>
                                {amount} шт.
                            </div>
                            <div className={styles.counterTotal}>
                                {amount * price} ₽
                            </div>
                        </div>
                    </li>
                ))}
            </ul>
            <div className={styles.chosenProducts}>
                <div>
                    Выбрано товаров
                </div>
                <div>{totalAmount} шт</div>
            </div>

            {
            orderOffer.paymentAmount > 0 
            ? <>
                <div className={styles.outline}/>
                <div className={styles.total}>
                    <div className={styles.totalTitle}>Оплачено:</div>
                    <div className={styles.price}>{orderOffer.paymentAmount} ₽</div>
                </div>
            </>
            : null
            }
            {
            orderOffer.remainingPaymentAmount > 0 
            ? <>
                <div className={styles.outline}/>
                    <div className={styles.total}>
                    <div className={styles.totalTitle}>Итого к оплате:</div>
                    <div className={styles.price}>{orderOffer.remainingPaymentAmount} ₽</div>
                </div>
            </>
            : null
            }
            <Button
                disabled={orderOffer.remainingPaymentAmount === 0}
                className={styles.btnOrder}
                type='regular'
                id='order-btn'
                onClick={() => getPaymentUrl(orderOffer.orderId)}
            >
                {orderOffer.remainingPaymentAmount === 0 ? 'Оплачено' : 'Оплатить заказ'}
            </Button>
        </>
    );
};